import PropTypes from 'prop-types';
import DropdownMenu from '../dropdown_menu';
import { useInfiniteDropdownData } from './util';

const InfiniteScrollDropdown = ({
  fetchFunction,
  queryKey,
  shouldFetch = true,
  pageSize = 20,
  staleTime = 5 * 60 * 1000,
  gcTime = 5 * 60 * 1000,
  transformOption,
  onFetchError,
  getNextPageParam,
  disablePortal = true,
  prependData = [],
  searchDebounceMs = 500,
  ...dropdownProps
}) => {
  const {
    data,
    pageCount,
    isLoading,
    isFetchingNextPage,
    fetchNextPage,
    hasNextPage,
    error,
    setSearchTerm,
  } = useInfiniteDropdownData({
    fetchFunction,
    queryKey,
    enabled: shouldFetch,
    pageSize,
    staleTime,
    gcTime,
    onError: onFetchError,
    getNextPageParam,
  });

  // ✅ Deduplicate
  const transformedData = Array.from(
    new Map(
      data.map((item) => {
        const opt = transformOption(item);
        return [opt.value, opt];
      })
    ).values()
  );

  // ✅ Prepend always
  const options = [...prependData, ...transformedData];

  return (
    <DropdownMenu
      disablePortal={disablePortal}
      options={options}
      onSearch={setSearchTerm}
      searchDebounceMs={searchDebounceMs}
      isLoading={isLoading || isFetchingNextPage}
      hasMore={hasNextPage}
      loadMore={fetchNextPage}
      error={
        typeof error?.response?.data?.message === 'string'
          ? error.response.data.message
          : error?.message || null
      }
      {...dropdownProps}
    />
  );
};

InfiniteScrollDropdown.propTypes = {
  // Infinite scroll props
  fetchFunction: PropTypes.func.isRequired,
  queryKey: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  shouldFetch: PropTypes.bool,
  disablePortal: PropTypes.bool,
  pageSize: PropTypes.number,
  staleTime: PropTypes.number,
  gcTime: PropTypes.number,
  searchDebounceMs: PropTypes.number,
  transformOption: PropTypes.func.isRequired,
  onFetchError: PropTypes.func,
  getNextPageParam: PropTypes.func,

  // Extra data props
  prependData: PropTypes.array,
};

export default InfiniteScrollDropdown;
